<template>
  <div class="bcWarp">
    <div class="inner">
      <div class="title">
        <img src="../assets/img/xstm.png" />
      </div>
      <h2>幸运靶场</h2>
      <ul class="bc">
        <li
          v-for="(item,index) in bcData.rangeList"
          :key="index"
        >
          <img
            :src="getImg(item,'bc')"
            alt=""
          >
          <p class="dates">{{bcData.Date}}</p>
          <p class="names">{{item}}</p>
        </li>
      </ul>
      <!--jx2 jx3-->
      <dl class="jx jx3">
        <dd
          v-for="(item,index) in jxData.jxList"
          :key="index"
        >
          <img
            :src="getImg(item,'jx')"
            alt=""
          >
          <p>{{item}}</p>
        </dd>

        <dt class="jx-date">{{jxData.Date}}</dt>
      </dl>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "versionBc",
  data() {
    return {
      // bc=>靶场 jx=>军需  **每次更新只需换下面数据** ImgSrc为道具ID，请先在后台添加好幸运靶场和军需补给箱数据后，按照其ID再来配置这里...
      bcImgMap: [
        //正在拓展src的地址 后续使用。旧版采用拼音缩写的，请全面替换成道具ID，如果是多个道具集合的，可继续使用自定义英文字符命名方式。
        { name: "神器碎片", src: "2198001" },
        { name: "弑血虫群核心模块", src: "2198002" },
        { name: "圣诞老人的袜子", src: "2198015" },
        { name: "冰块", src: "33568" },
        { name: "啪啪啪的雪球", src: "2198018" },
        { name: "超能-制导手雷核心模块", src: "2198041" },
        { name: "超能-爆裂子母雷核心模块", src: "2198064" },
        { name: "窒息寒霜核心模块", src: "2198065" },
        { name: "落日燎原核心模块", src: "2198075" },
        { name: "百发百中核心模块、毁灭镭射核心模块、闪电枷锁核心模块、连珠炮核心模块", src: "4hexin" },
        { name: "地狱浩劫核心模块、碎星炮核心模块、毒液之牙核心模块、疾雨流星核心模块", src: "4mk" },
        { name: "苍穹回响核心模块、毁灭之轮核心模块、不灭冷焰核心模块、寒霜先锋核心模块", src: "4mk" },

        { name: "热能吸收器（永久）", src: "20081" },
        { name: "供弹器（永久）", src: "25021" },
        { name: "供弹器II型（永久）", src: "25022" },
        { name: "供弹器III型以小搏大包", src: "gdq3" },
        { name: "便携手雷包", src: "20111" },
        { name: "体质增强器（永久）", src: "25001" },
        { name: "体质增强器II型（永久）", src: "25002" },
        { name: "体质增强器III型以小搏大包", src: "25006" },
        { name: "破片过滤网（永久）", src: "20051" },
        { name: "医疗装置II型（永久）", src: "20022" },
        { name: "破片过滤网III型以小搏大包", src: "20054" },
        { name: "医疗装置III型以小搏大包", src: "20025" },
        { name: "医疗装置（永久）", src: "20021" },
        { name: "移动装置（永久）", src: "20001" },
        { name: "快手装置（永久）", src: "20231" },
        { name: "急救装置（永久）", src: "20071" },
        { name: "干扰装置（永久）", src: "20211" },
        { name: "顽强意志（永久）", src: "20251" },
        { name: "移动装置II型（永久）", src: "20002" },
        { name: "移动装置III型以小搏大包", src: "20005" },
        { name: "力量增幅器（永久）", src: "20041" },
        { name: "力量增幅器II型（永久）", src: "34320" },
        { name: "力量增幅器III型以小搏大包", src: "20044" },
        { name: "自动装填装置（永久）", src: "20121" },
        { name: "静音装置（永久）", src: "20011" },
        { name: "爆破辅助装置（永久）", src: "20161" },
        { name: "感光护镜", src: "20031" },
        { name: "心星之印", src: "2198031" },
        
        { name: "圣诞快乐（名片）", src: "33090" },
        { name: "愚者无畏（名片）", src: "33131" },
        { name: "新年快乐（名片）", src: "33127" },
        { name: "锦瑟年华（名片）（永久）", src: "33133" },
        { name: "天元地宵赏花灯（永久）", src: "33039" },

        { name: "春花水暖辞旧岁（永久）、一枪倾心（名片）（永久）", src: "chsnyqqx" },
        { name: "超能-闪电枷锁(3/7天)概率翻3倍、冰块", src: "sdjs_bk" },
        { name: "毁灭者专属材料、冻结者专属材料", src: "djhm" },
        
        { name: "超能-毁灭之轮（3/7天）概率翻五倍", src: "8516" },
        { name: "超能-毁灭之轮（3天/7天）", src: "8516" },
        { name: "暴君-原始咆哮（3/7天）概率翻五倍", src: "2050" },
        { name: "超能-毁灭镭射（3/7天）概率翻五倍", src: "8527" },
        { name: "超能-闪电枷锁(3/7天)概率翻3倍", src: "8515" },
        { name: "时限传承-大地撕裂者 Mk.6概率翻倍", src: "6587" },
        { name: "传承-大地撕裂者 Mk.6概率翻倍", src: "6587" },
        { name: "传承-大地撕裂者 MK.6概率翻倍", src: "6587" },
        { name: "传承-大地撕裂者 Mk.1", src: "6582" },
        { name: "传承-哀伤之霜 Mk.6概率翻倍", src: "5716" },
        { name: "传承-哀伤之霜 MK.6概率翻倍", src: "5716" },
        { name: "传承-海心之焰 Mk.6概率翻倍", src: "8542" },
        { name: "传承-海心之焰 MK.6概率翻倍", src: "8542" },
        { name: "传承-海心之焰 Mk.1", src: "8537" },
        { name: "传承-冥河摆渡人 Mk.6概率翻倍", src: "2713" },
        { name: "传承-冥河摆渡人 MK.6概率翻倍", src: "2713" },
        { name: "传承-冥河摆渡人 Mk.1", src: "2708" },
        { name: "传承-蛛丝尘网 Mk.1", src: "7045" },
        { name: "传承-邪能行者 Mk.1", src: "6547" },
        { name: "传承-邪能行者 Mk.6概率翻倍", src: "6552" },
        { name: "传承-邪能行者 MK.6概率翻倍", src: "6552" },
        { name: "传承-时空雕刻家 Mk.6概率翻倍", src: "8597" },
        { name: "传承-时空雕刻家 MK.6概率翻倍", src: "8597" },
        { name: "传承-时空雕刻家 Mk.1", src: "8601" },
        { name: "鎏金骑士碎片（蓝/紫/橙）", src: "2042" },
        { name: "毒液之牙碎片", src: "8535" },
        { name: "战灵-毁灭者（永久）", src: "2032" },
        // { name: "战灵-冻结者（永久）", src: "2033" },
        { name: "战灵-冻结者", src: "2033" },
        { name: "战灵UMP", src: "3019" },
        { name: "弑血虫群-孵化", src: "1621" },
        { name: "丘比特之箭（永久）", src: "8506" },
        { name: "圣诞-鲁道夫之角", src: "5571" },
        { name: "鲁道夫之角专属材料", src: "2198102" }
      ],
      jxImgMap: [
        //正在拓展src的地址 后续使用
        { name: "死亡之翼时空箱（稀有）", src: "88045" },
        { name: "X战机时空箱（稀有）", src: "88037" },
        { name: "离子先锋时空箱（稀有）", src: "88041" },
        { name: "天空杀手时空箱（稀有）", src: "88008" },
        { name: "歼星巨龙时空箱（稀有）", src: "88025" },

        { name: "炼狱挽歌", src: "36038" },
        { name: "末日救世主套装", src: "99999" },

        { name: "无尽P90", src: "3562" },
        { name: "无尽P90专属材料", src: "2198094" },
        { name: "无尽RPD", src: "6561" },
        { name: "泰山G36", src: "2761" },
        { name: "泰山Sako M90", src: "2741" },
        { name: "泰山Sako M90专属材料", src: "2198083" },
        // { name: "炎龙Barret M82（永久）", src: "5561" },
        { name: "炎龙Barret M82", src: "5561" },
        { name: "教官A2", src: "2058" },
        { name: "神行QJY88", src: "6542" },
        { name: "鹰眼PP-19 Bizon", src: "3641" },
        { name: "鹰眼T.50雷帝", src: "1601" },
        { name: "鹰眼T.50雷帝专属材料", src: "2198090" },

        { name: "圣诞老人的袜子", src: "2198015" },
        { name: "啪啪啪的雪球", src: "2198018" },
        { name: "心星之印", src: "2198031" },
        { name: "设计图：晶能电源 Mk.6", src: "10230101" }
      ]
    };
  },
  computed: {
    ...mapGetters(["bcData", "jxData"])
  },
  created() {
    // console.log("bc_created");
  },
  mounted() {
    // console.log("bc_mounted");
  },
  methods: {
    getImg(name, type) {
      var src = "",
        searchArr = [];
      if (type === "bc") {
        searchArr = this.bcImgMap;
      } else if (type === "jx") {
        searchArr = this.jxImgMap;
      }
      searchArr.forEach(function(val) {
        if (name.indexOf(val.name) !== -1) {
          src = val.src;
        }
      });

      if (!src) {
        // console.log(name);
      } else {
        // return require("http://cdn1.zygames.com/qqsm/t1/s/" + src + ".png");
        return "http://cdn1.zygames.com/qqsm/t1/s/" + src + ".png";
      }
    } //用require编译图片地址  之后可能放在static 文件下
  }
};
</script>

<style lang="scss" scoped>
.inner {
  width: 1200px;
  margin: 0 auto;
  padding-top: 1px;
}
.bcWarp {
  background: url("../assets/img/bg5.jpg") no-repeat top center;
  height: 1001px;
  position: relative;
  min-width: 1200px;
  .title {
    padding-top: 66px;
    position: relative;
  }
  h2 {
    color: #ffdb8d;
    font-size: 42px;
    margin-left: 508px;
    text-align: left;
  }
  .bc {
    padding-top: 28px;
    height: 297px;
    li {
      padding-right: 20px;
      width: 280px;
      height: 297px;
      float: left;
      position: relative;
      img {
        display: inline-block;
        margin-top: 121px;
        margin-left: 20px;
        width: 259px;
        height: 131px;
      }
      .dates {
        font-size: 14px;
        color: #ffd98a;
        position: absolute;
        top: 39px;
        left: 59px;
      }
      .names {
        font-size: 14px;
        color: #ffc958;
        position: absolute;
        top: 257px;
        left: 24px;
        width: 256px;
        text-align: center;
      }
    }
    li:nth-child(1) {
      background: url("../assets/img/zs-bc.png") no-repeat;
      height: 309px;
      p {
        color: #64baff;
      }
    }
    li:nth-child(2) {
      background: url("../assets/img/bc-1.png") no-repeat;
      p {
        color: #ffd98a;
      }
    }
    li:nth-child(3) {
      background: url("../assets/img/bc-2.png") no-repeat;
      p {
        color: #f0d743;
      }
    }
    li:nth-child(4) {
      background: url("../assets/img/bc-3.png") no-repeat;
      p {
        color: #d0d0d0;
      }
    }
  }
  .jx {
    height: 312px;
    margin: 47px auto 0 auto;
    margin-top: 47px; /*换三个屏蔽这俩*/
    position: relative;
    &.jx2{
      width: 964px;
      background: url("../assets/img/jx.png") no-repeat center top;
      dd{
        width: 442px; /*两个*/
      }
    }
    &.jx3{
      width: 1200px;
      // margin-left: 110px; /*换三个屏蔽这俩*/
      background: url("../assets/img/jx2.png") no-repeat center top;
      dd{
        width: 349px; /*三个*/
        padding: 75px 20px 0 20px; /*三个*/
      }
    }
    dd {
      float: left;
      
      
      
      padding: 75px 0 0 32px;
      color: #28cac4;
      font-size: 16px;
      img {
        display: inline-block;
        width: 240px;
        height: 135px;
        padding: 15px 30px;
      }
    }
    dt {
      color: #28cac4;
      font-size: 16px;
      position: absolute;
      top: 47px;
      width: 280px;
      left: 50%;
      margin-left: -140px;
      text-align: center;
    }
  }
}
</style>
















// WEBPACK FOOTER //
// src/components/qqsmVersion_bc.vue